import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router";
import { PulseLoader } from "react-spinners";
import CancelModal from "../../../../../../components/cancel-modal/cancel-modal";
import { useErrorAlert } from "../../../../../../components/error-alert/error-alert";
import TaskTypesCreationModal from "../../task-types-creation/components/task-types-creation-modal";
import {
  createTaskType,
  editTaskType,
  getTaskTypeByType,
} from "../../task-types-creation/task-types-creation-util";
import AdminDynamicFieldsTemplate from "../dynamic-fields-panel/components/admin-dynamic-fields-template";
import taskReminderIcon from "../../../../../../assets/icons/Task-Reminder-16px-Blue-60.svg";
import defaultDurationIcon from "../../../../../../assets/icons/Icon - Tasks.svg";
import WorkflowIcon from "../../../../../../assets/icons/Icon-Workflow-16px-Blue.svg";

import {
  fetchDynamicFieldsDesigner,
  fetchObjectTypes,
  saveDynamicFields,
} from "../utils/admin-dynamic-fields-util.js";
import { getTimeFromTimeStamp } from "../../../../../../util/time-helpers";
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import "./admin-dynamic-fields-page.scss";
import { FluentTime } from "../../../../../../components/FluentUI/Fluent-Time";
import { TriyoForm } from "../../../../../../components/TriyoForm";
import { Formik } from "formik";
import * as yup from "yup";
import { GetAllWorkflows } from "../../../../../../services/api/workflow-api";
import { NIL as NIL_UUID } from 'uuid';

const adminDynamicFieldsPageArea = "admin-dynamic-fields-page";

const AdminDynamicFieldsPage = () => {
  const history = useHistory();
  const [objectTypes, setObjectTypes] = useState([]);
  const { alertError, setAlertError, ErrorAlert, errorAlertProps } =
    useErrorAlert();
  const [taskType, setTaskType] = useState(
    history.location.state?.taskType ?? {
      Id: history.location.pathname.split("/").pop() ?? 0,
      Type: "",
      IsPublic: true,
      Days: 1,
      WorkflowId: NIL_UUID,
    }
  );
  const [dynamicFields, setDynamicFields] = useState([]);
  const [taskTypeDuration, setTaskTypeDuration] = useState(1);
  const [taskTypeDurationInterval, setTaskTypeDurationInterval] = useState({
    id: 1,
    name: "Days",
  });
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const [customReminders, setCustomReminders] = useState([]);
  const [activeWorkflows, setActiveWorkflows] = useState([]);
  const [enableCustomizedWorkflow, setEnableCustomizedWorkflow] = useState(false);

  const reminderHelpers = {
    setOneTime: () => {
      setTaskReminder((prevState) => ({
        ...prevState,
        reminder: { id: "2", name: "Before Due Date" },
      }));
    },

    updateExist: () => {
      setTaskReminder((prevState) => ({
        ...prevState,
        exist: !prevState.exist,
      }));
    },
    setOnDueDate: () => {
      setTaskReminder((prevState) => ({
        ...prevState,
        reminder: { id: "0", name: "On End Date" },
      }));
    },
    handleChange: (change, value) => {
      setTaskReminder((prevState) => ({
        ...prevState,
        [change]: value,
      }));
      console.log("TR change -->");
      console.log(taskReminder);
    },

    setRecurring: () => {
      setTaskReminder((prevState) => ({
        ...prevState,
        reminder: { id: "1", name: "Recurring" },
      }));
    },

    setCustom: () => {
      setTaskReminder((prevState) => ({
        ...prevState,
        reminder: { id: "4", name: "Custom" },
      }));
    },

    getReminderDetails: () => {
      if (taskReminder.reminder.id == 0) {
        return {
          reminderOnDueDate: true,
          reminderOneTime: false,
          reminderOneTimeDaysBefore: 0,
          reminderOneTimeTime: getTimeFromTimeStamp(taskReminder.time),
          reminderRecurring: null,
          reminderRecurringTime: null,
        };
      }

      if (taskReminder.reminder.id == 1) {
        return {
          reminderOnDueDate: false,
          reminderOneTime: false,
          reminderOneTimeDaysBefore: 0,
          reminderOneTimeTime: null,
          reminderRecurring: taskReminder.reminderRecurring.name,
          reminderRecurringTime: getTimeFromTimeStamp(taskReminder.time),
          ...(taskReminder.reminderRecurring.name === "Custom" && {
            reminderRecurringIntervalType:
              taskReminder.reminderRecurringIntervalType.name,
            reminderRecurringIntervalValue: taskReminder.days,
          }),
        };
      }

      if (taskReminder.reminder.id == 2 || taskReminder.reminder.id == 3) {
        return {
          reminderOnDueDate: false,
          reminderOneTime: true,
          reminderOneTimeDaysBefore: taskReminder.days,
          reminderOneTimeTime: getTimeFromTimeStamp(taskReminder.time),
          reminderRecurring: null,
          reminderRecurringTime: null,
        };
      }
    },
    emptyReminderObject: () => {
      return {
        exist: false,
        reminder: reminderHelpers.reminderValues[0],
        reminderRecurring: reminderHelpers.reminderRecurringValues[0],
        reminderRecurringIntervalType:
          reminderHelpers.reminderRecurringIntervalTypeValues[0],
        time: new Date().setHours(9, 30),
        days: 2,
      };
    },
    reminderValues: [
      { id: "2", name: "Before Due Date" },
      { id: "3", name: "After Start Date" },
    ],
    reminderRecurringValues: [
      { id: "1", name: "Daily" },
      { id: "2", name: "Weekly" },
      { id: "3", name: "Monthly" },
      { id: "5", name: "Hourly" },
      { id: "6", name: "Custom" },
    ],
    reminderRecurringIntervalTypeValues: [
      { id: "1", name: "Days" },
      { id: "2", name: "Weeks" },
      { id: "3", name: "Months" },
      { id: "4", name: "Years" },
      { id: "5", name: "Business Days" },
    ],
    allReminderValues: [
      { id: "0", name: "On End Date" },
      { id: "1", name: "Recurring" },
      { id: "2", name: "Before Due Date" },
      { id: "3", name: "After Start Date" },
      { id: "4", name: "Custom" },
    ],
    getReminderDetailsFromTask: (task) => {
      const newObject = reminderHelpers.emptyReminderObject();
      newObject.exist = true;
      newObject.name = task.Name;
      newObject.reminder = getValueFromName(
        reminderHelpers.allReminderValues,
        task.Reminder
      );
      newObject.time = new Date(task.ReminderOneTimeTime);
      if (task.Reminder === "Recurring") {
        newObject.reminderRecurring = getValueFromName(
          reminderHelpers.reminderRecurringValues,
          task.ReminderRecurring
        );
        newObject.time = new Date(task.ReminderRecurringTime);
        if (task.ReminderRecurring === "Custom") {
          newObject.reminderRecurringIntervalType = getValueFromName(
            reminderHelpers.reminderRecurringIntervalTypeValues,
            task.ReminderRecurringIntervalType
          );
          newObject.days = task.ReminderRecurringIntervalValue;
        }
      } else if (
        task.Reminder === "Before Due Date" ||
        task.Reminder === "After Start Date"
      ) {
        newObject.days = task.ReminderOneTimeDaysBefore;
      } else if (task.Reminder === "Custom") {
        newObject.customreminders = task.CustomReminders;
      }

      return newObject;
    },
  };

  const customReminderHelpers = {
    reminderValues: [
      { id: "Before Due Date", name: "Before Due Date" },
      { id: "After Start Date", name: "After Start Date" },
    ],
    reminderRecurringIntervalTypeValues: [
      { id: "Days", name: "Day(s)" },
      { id: "Business Days", name: "Business Day(s)" },
      { id: "Weeks", name: "Week(s)" },
      { id: "Months", name: "Month(s)" },
      { id: "Years", name: "Year(s)" },
    ],
  };
  const [taskReminder, setTaskReminder] = useState(
    reminderHelpers.emptyReminderObject()
  );

  const editMode = taskType.Id > 0;

  const { promiseInProgress } = usePromiseTracker({
    area: adminDynamicFieldsPageArea,
  });

  const getValueFromName = (values, name) => {
    return values.find((value) => value.name === name);
  };

  const loadDurationFields = (days, IsBusinessDays) => {
    let durationAmount = days;
    let selectedDurationOption = { id: 1, name: "Days" };
    if (IsBusinessDays) {
      selectedDurationOption = { id: 2, name: "Business Days" };
    } else if (days % 365 === 0) {
      selectedDurationOption = { id: 365, name: "Years" };
      durationAmount = days / 365;
    } else if (days % 30 === 0) {
      selectedDurationOption = { id: 30, name: "Months" };
      durationAmount = days / 30;
    } else if (days % 7 === 0) {
      selectedDurationOption = { id: 7, name: "Weeks" };
      durationAmount = days / 7;
    }

    setTaskTypeDurationInterval(selectedDurationOption);
    setTaskTypeDuration(durationAmount);
  };
  const taskTypeDurationOptions = [
    { id: 1, name: "Days" },
    { id: 2, name: "Business Days" },
    { id: 7, name: "Weeks" },
    { id: 30, name: "Months" },
    { id: 365, name: "Years" },
  ];

  const state = {
    taskReminder: reminderHelpers.emptyReminderObject(),
  };

  async function loadObjectTypes() {
    try {
      const objectTypesPromise = await trackPromise(
        fetchObjectTypes(),
        adminDynamicFieldsPageArea
      );
      setObjectTypes(objectTypesPromise);
    } catch (error) {
      setAlertError({
        alertAction: "Error Loading Object Types",
        alertMessage: error.toString(),
      });
    }
  }

  function onCancel() {
    setShowCancelModal(true);
  }

  const isDynamicFieldsInvalid = dynamicFields.some((field) => {
    if (field.Label.length < 1) {
      return true;
    }
    if (field.Lookup) {
      if (!(!!field.LookupValues[0] && !!field.LookupValues[1])) {
        return true;
      }
    }
    return false;
  });

  async function loadDynamicFields(taskTypeId) {
    try {
      setDynamicFields(await fetchDynamicFieldsDesigner(taskTypeId));
    } catch (error) {
      setAlertError({
        alertAction: "Error Loading Dynamic Fields",
        alertMessage: error.toString(),
      });
    }
  }

  async function submitForm() {
    try {
      setChecked(true);
      if (isDynamicFieldsInvalid) {
        return null;
      }
      const existingTaskType = await trackPromise(
        getTaskTypeByType(taskType.Type),
        adminDynamicFieldsPageArea
      );

      if (existingTaskType && existingTaskType.Id !== taskType.Id) {
        setAlertError({
          alertAction: `Unable to ${editMode ? "Edit" : "Create"} Task Type!`,
          alertMessage: "This task type name already exists.",
          timer: 5000,
        });
        return;
      }

      var taskTypeRequest = {
        Name: taskReminder.name,
        CreatorUserId: taskType?.CreatorUserId,
        CurrentUser: taskType?.CurrentUser,
        Id: taskType?.Id,
        IsOnDashboard: taskType?.IsOnDashboard,
        IsPublic: taskType?.IsPublic,
        IsVisible: taskType?.IsVisible,
        Type: taskType?.Type,
        Days: taskType?.Days,
        IsBusinessDays: taskType?.IsBusinessDays,
        WorkflowId: taskType?.WorkflowId,
        CustomReminders: customReminders,
        ...(taskReminder.exist && {
          reminder: taskReminder.reminder.name,
          ...reminderHelpers.getReminderDetails(),
        }),
      };

      const newTaskType = await trackPromise(
        editMode
          ? editTaskType(taskTypeRequest)
          : createTaskType(taskTypeRequest),
        adminDynamicFieldsPageArea
      );
      setTaskType(newTaskType);
      await trackPromise(
        saveDynamicFields(newTaskType.Id, 0, dynamicFields),
        adminDynamicFieldsPageArea
      );
      await loadDynamicFields(newTaskType.Id);
      setChecked(false);
      setShowModal(true);
    } catch (error) {
      setAlertError({
        alertAction: "Error Saving Task Type",
        alertMessage: error.toString(),
      });
    }
  }

  useEffect(() => {
    loadObjectTypes();
    GetWorkflows();
    if (!taskType) return;
    if (taskType.Reminder) {
      setTaskReminder(reminderHelpers.getReminderDetailsFromTask(taskType));
    }
    if (taskType.CustomReminders) {
      taskType?.CustomReminders.map((cr) => {
        cr.ReminderTime = new Date(cr.ReminderTime);
        return cr;
      });
      setCustomReminders(taskType.CustomReminders);
    }
    if(taskType.WorkflowId != NIL_UUID){
      setEnableCustomizedWorkflow(true);
    }

    loadDurationFields(taskType.Days, taskType.IsBusinessDays);
    loadDynamicFields(taskType.Id);
  }, []);

  const GetWorkflows = () => {
    GetAllWorkflows()
      .then((res) => {
        if (res.status === 200) {
          let result = res.data.filter((obj) => {
            if (obj.Id == taskType.WorkflowId && obj.Deleted) {
              return true;
            }
            else {
              return obj.Deleted === false;
            }
          });
          setActiveWorkflows(result);
        }
      })
      .catch((err) => {
        console.log("Error [GetAllWorkflows] => ", err);
      });
  }

  const isTaskTypeNameInvalid =
    taskType.Type.length === 0 || !/\S/.test(taskType.Type);

  const disableSubmit =
    checked && (isTaskTypeNameInvalid || isDynamicFieldsInvalid);

  const onChangeTaskTypeDurationInterval = (selectedValue) => {
    setTaskTypeDurationInterval(selectedValue);
  };

  const onChangeTaskTypeDuration = (value) => {
    setTaskTypeDuration(value);
  };

  const isInt = (value) => {
    return (
      !isNaN(value) &&
      parseInt(Number(value)) === value &&
      !isNaN(parseInt(value, 10))
    );
  };

  const getValidDaysTaskType = (time, intervals) => {
    let nDays = parseInt(time);
    let checkValidDays = isInt(nDays);
    let validDays = 1;
    let isBusinessDays = false;
    if (checkValidDays) {
      if (intervals === "Days") {
        validDays = nDays * 1;
      } else if (intervals == "Business Days") {
        validDays = nDays * 1;
        isBusinessDays = true;
      } else if (intervals === "Weeks") {
        validDays = nDays * 7;
      } else if (intervals === "Months") {
        validDays = nDays * 30;
      } else if (intervals === "Years") {
        validDays = nDays * 365;
      }
    }

    setTaskType({
      ...taskType,
      Days: validDays,
      IsBusinessDays: isBusinessDays,
    });
  };

  //#region Custom Reminder Helper Functions
  const deleteReminder = (removeIdx) => {
    setCustomReminders(customReminders.filter((_, idx) => removeIdx !== idx));
  };
  const addReminder = () => {
    let newTime = new Date();
    newTime.setHours(9);
    newTime.setMinutes(30);
    let newObject = {
      Id: 0,
      Unit: "1",
      Period: "Days",
      ReminderType: "After Start Date",
      ReminderTime: newTime,
    };
    setCustomReminders([...customReminders, newObject]);
  };

  const reminderChangeHandler = (field, newValue, idx) => {
    const updatedReminders = customReminders.map((cr, index) =>
      idx === index ? { ...cr, [field]: newValue } : cr
    );
    setCustomReminders(updatedReminders);
  };

  const addDateZeroes = (value, prepend) => {
    if (value.toString().length == 1) {
      if (prepend) {
        return '0' + value.toString();
      }
      else {
        return value.toString() + '0';
      }
    }
    return value;
  }

  //#endregion

  if (promiseInProgress) {
    return (
      <div className="pulse-loader">
        <PulseLoader />
      </div>
    );
  }

  return (
    <div className="admin-dynamic-fields-page-wrapper">
      <div className="template-creation-panel">
        {alertError.showAlert && <ErrorAlert {...errorAlertProps} />}
        <h4 className="panel-title">
          {editMode ? "Edit Task Type" : "Create Task Type"}
        </h4>
        <Helmet>
          <title>{`TRIYO · ${editMode ? taskType.Type : "Create Task Type"
            }`}</title>
        </Helmet>
        <Formik
          validationSchema={yup.object({
            reminderDays: yup
              .number()
              .integer()
              .required("Number of days required"),
            day: yup
              .number()
              .typeError("Please select duration of more than 1")
              .required("Task Type Duration Required")
              .min(1, "Please select dates within the range of 1-365 days"),
          })}
          initialValues={{
            day: taskTypeDuration,
            dayDuration: taskTypeDurationInterval,
          }}
        >
          {({
            setFieldValue,
            setFieldTouched,
            handleSubmit,
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
          }) => (
            <Form
              onSubmit={(e) => e.preventDefault()}
              className="form-container"
            >
              <Form.Row className="form-row">
                <Form.Group className="left-row">
                  <Form.Label>
                    Task Type Name <span className="red">*</span>
                  </Form.Label>
                  <Form.Control
                    name="Type"
                    placeholder="Enter Task Type Name"
                    value={taskType.Type}
                    onChange={(e) =>
                      setTaskType({
                        ...taskType,
                        Type: e.target.value,
                        touched: true,
                      })
                    }
                    isInvalid={isTaskTypeNameInvalid && taskType.touched}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className="inline-error"
                  >
                    Please enter a Name
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="right-row">
                  <Form.Label>Access to Task Type</Form.Label>
                  <div className="template-access">
                    <Form.Check
                      className="public-access"
                      type="checkbox"
                      name="IsPublic"
                      value={taskType.Type}
                      checked={taskType.IsPublic}
                      onChange={(e) =>
                        setTaskType({
                          ...taskType,
                          Type: e.target.value,
                          IsPublic: !taskType.IsPublic,
                        })
                      }
                      label="Public"
                      isInvalid={touched.IsPublic && errors.IsPublic}
                    />

                    <Form.Check
                      className="private-access"
                      type="checkbox"
                      name="IsPublic"
                      value={taskType.Type}
                      checked={!taskType.IsPublic}
                      onChange={(e) =>
                        setTaskType({
                          ...taskType,
                          Type: e.target.value,
                          IsPublic: !taskType.IsPublic,
                        })
                      }
                      label="Private"
                      isInvalid={touched.IsPublic && errors.IsPublic}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.IsPublic}
                    </Form.Control.Feedback>
                  </div>
                </div>
              </Form.Row>

              <Form.Row className="form-row">
                <div className="template-task-form-container">
                  <div className="template-task-left-sub-panel task-accordion-container">
                    <Form.Group>
                      <div className="heading">
                        <div className="heading-description">
                          <img
                            className="heading-image"
                            alt=""
                            src={defaultDurationIcon}
                          />
                          <h4 className="heading-name">Default Duration</h4>
                        </div>
                      </div>
                      <div className="elements-container durationLabel">
                        <span>
                          Default Duration{" "}
                          <span style={{ color: "red" }}> * </span>
                        </span>
                      </div>
                      <div className="duration-container">
                        <Form.Control
                          id="day"
                          name="day"
                          className="duration-input"
                          placeholder="Enter Duration"
                          onKeyDown={(e) => {
                            (e.key === "Enter" ||
                              e.key === "." ||
                              e.key === "-") &&
                              e.preventDefault();
                          }}
                          onChange={(e) => {
                            e.target.value =
                              e.target.value == 0 ? 1 : e.target.value;
                            getValidDaysTaskType(
                              e.target.value,
                              taskTypeDurationInterval.name
                            );
                            handleChange(e);
                            onChangeTaskTypeDuration(e.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.day}
                          isInvalid={touched.day && errors.day}
                          feedback={errors.day}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="inline-error duration-error"
                        >
                          {errors.day}
                        </Form.Control.Feedback>
                        <div className="duration-dropdown">
                          <DropdownMain
                            values={taskTypeDurationOptions}
                            onSelect={(selected) => {
                              getValidDaysTaskType(values.day, selected.name);
                              onChangeTaskTypeDurationInterval(selected);
                            }}
                            currentSelected={taskTypeDurationInterval}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </div>
              </Form.Row>

              <Form.Row className="form-row">
                <div className="task-accordion-container task-reminders">
                  <div className="heading">
                    <div className="heading-description">
                      <img
                        className="heading-image"
                        alt="Workflow Icon"
                        src={WorkflowIcon}
                      />
                      <h4 className="heading-name">Enable Customized Workflow</h4>
                    </div>
                    <TriyoForm.Toggle
                      id="custom-switch"
                      checked={enableCustomizedWorkflow}
                      onChange={(e) => {
                        if(!enableCustomizedWorkflow){
                          setTaskType({ ...taskType, WorkflowId: taskType.WorkflowId});
                        }
                        else{
                          setTaskType({ ...taskType, WorkflowId: NIL_UUID});
                        }
                        setEnableCustomizedWorkflow(!enableCustomizedWorkflow);
                      }}
                    />
                  </div>
                  <div className="workflow-subtext">
                    Toggle to enable customized workflow. Turning the toggle off will apply the base task flow.
                  </div>
                  <div className="workflow-subtext">
                    Customized Workflow:
                  </div>
                  <div className="workflow-dropdown">
                    <DropdownMain
                      values={activeWorkflows.map((wf) => {
                        return { id: wf.Id, name: wf.Name + (wf.Deleted ? " - Archived" : "") };
                      })
                      }
                      dropdownButtonText={"Select a customized workflow"}
                      onSelect={(selectedValue) => {
                        setTaskType({ ...taskType, WorkflowId: selectedValue.id });
                      }}
                      currentSelected={taskType.WorkflowId == NIL_UUID ? null : {id: taskType.WorkflowId}}
                      disabled={!enableCustomizedWorkflow}
                    />
                  </div>

                </div>
              </Form.Row>

              <Form.Row className="form-row">
                <div className="task-accordion-container task-reminders">
                  <div className="heading">
                    <div className="heading-description">
                      <img
                        className="heading-image"
                        alt="Reminder Icon"
                        src={taskReminderIcon}
                      />
                      <h4 className="heading-name">Set Task Reminders</h4>
                    </div>
                    <TriyoForm.Toggle
                      id="custom-switch"
                      checked={taskReminder.exist}
                      onChange={() => {
                        reminderHelpers.updateExist();
                      }}
                    />
                  </div>
                  <>
                    <div className="elements-container">
                      <div className="reminder-options-container">
                        <div
                          onClick={() => {
                            if (taskReminder.exist)
                              reminderHelpers.setOnDueDate();
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="reminders"
                            checked={taskReminder.reminder.id == 0}
                            label="On Due Date"
                            disabled={!taskReminder.exist}
                          />
                        </div>
                        <div
                          onClick={() => {
                            if (taskReminder.exist)
                              reminderHelpers.setOneTime();
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="reminders"
                            checked={
                              taskReminder.reminder.id == 2 ||
                              taskReminder.reminder.id == 3
                            }
                            label="One-Time"
                            disabled={!taskReminder.exist}
                          />
                        </div>
                        <div
                          onClick={() => {
                            if (taskReminder.exist)
                              reminderHelpers.setRecurring();
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="reminders"
                            checked={taskReminder.reminder.id == 1}
                            label="Recurring"
                            disabled={!taskReminder.exist}
                          />
                        </div>
                        <div
                          onClick={() => {
                            if (taskReminder.exist)
                              reminderHelpers.setCustom();
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            name="reminders"
                            checked={taskReminder.reminder.id == 4}
                            label="Custom"
                            disabled={!taskReminder.exist}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`elements-container elements-container-no-margin ${taskReminder.reminder.id == 0 ||
                        taskReminder.reminder.id == 1 ||
                        taskReminder.reminder.id == 2 ||
                        taskReminder.reminder.id == 3
                        ? "show"
                        : "no-show"
                        }`}
                    >
                      <div className="durationLabel">
                        <span>Reminder Name (optional)</span>
                      </div>
                    </div>
                    <div
                      className={`reminder-name-container elements-container ${taskReminder.reminder.id == 0 ||
                        taskReminder.reminder.id == 1 ||
                        taskReminder.reminder.id == 2 ||
                        taskReminder.reminder.id == 3
                        ? "show"
                        : "no-show"
                        }`}
                    >
                      <div className="non-custom-reminder-name">
                        <input
                          id="reminderName"
                          name="reminderName"
                          value={taskReminder.name}
                          type="text"
                          onChange={(e) => {
                            reminderHelpers.handleChange("name", e.target.value);
                          }}
                          disabled={!taskReminder.exist}
                          placeholder="For example, Follow-up #1, Reminder #1, etc."
                          className="big-element"
                          maxLength={56}
                        />
                        <span>Enter a maximum of 56 characters.</span>

                      </div>

                    </div>
                    <div
                      className={`elements-container elements-container-no-margin ${taskReminder.reminder.id == 0 ||
                        taskReminder.reminder.id == 1 ||
                        taskReminder.reminder.id == 2 ||
                        taskReminder.reminder.id == 3
                        ? "show"
                        : "no-show"
                        }`}
                    >
                      <div className="durationLabel">
                        <span>Reminder Time</span>
                      </div>
                    </div>
                    <div
                      className={`elements-container ${taskReminder.reminder.id == 0 ? "show" : "no-show"
                        }`}
                    >
                      <FluentTime
                        className="big-element"
                        value={taskReminder.time}
                        onChange={(value) =>
                          reminderHelpers.handleChange("time", value)
                        }
                        timeIntervals={15}
                        disabled={!taskReminder.exist}
                      />
                    </div>
                    {(taskReminder.reminder.id == 2 ||
                      taskReminder.reminder.id == 3) && (
                        <div className="one-time-recurrence-container">
                          <input
                            id="reminderDays"
                            name="reminderDays"
                            value={taskReminder.days}
                            type="number"
                            defaultValue={2}
                            min={1}
                            required
                            onKeyDown={(e) => {
                              (e.key === "Enter" ||
                                e.key === "." ||
                                e.key === "-") &&
                                e.preventDefault();
                            }}
                            onChange={(e) => {
                              e.target.value =
                                e.target.value == 0 ? 1 : e.target.value;
                              reminderHelpers.handleChange(
                                "days",
                                e.target.value
                              );
                            }}
                            isInvalid={errors?.reminderDays}
                            disabled={!taskReminder.exist}
                            onBlur={() => {
                              setFieldTouched("reminderDays");
                            }}
                          />

                          <h4>days</h4>

                          <div className="reminder-dropdown">
                            <DropdownMain
                              values={reminderHelpers.reminderValues}
                              dropdownButtonText={"-Select-"}
                              onSelect={(selectedValue) => {
                                reminderHelpers.handleChange(
                                  "reminder",
                                  selectedValue
                                );
                              }}
                              currentSelected={taskReminder.reminder}
                              disabled={!taskReminder.exist}
                            />
                          </div>

                          <h4>at</h4>

                          <div className="reminder-date-picker">
                            <FluentTime
                              value={taskReminder.time}
                              onChange={(value) =>
                                reminderHelpers.handleChange("time", value)
                              }
                              timeIntervals={15}
                              disabled={!taskReminder.exist}
                            />
                          </div>
                        </div>
                      )}
                    <Form.Control.Feedback
                      type="invalid"
                      className="inline-error"
                    >
                      {errors.reminderDays}
                    </Form.Control.Feedback>

                    <div
                      className={`elements-container ${taskReminder.reminder.id == 1 ? "show" : "no-show"
                        }`}
                    >
                      <div className="left-element">
                        <DropdownMain
                          values={reminderHelpers.reminderRecurringValues}
                          dropdownButtonText={"-Select-"}
                          onSelect={(selectedValue) => {
                            reminderHelpers.handleChange(
                              "reminderRecurring",
                              selectedValue
                            );
                          }}
                          currentSelected={taskReminder.reminderRecurring}
                          disabled={!taskReminder.exist}
                        />
                      </div>
                      <div className="mid-element"></div>

                      <div className="right-element">
                        <FluentTime
                          value={taskReminder.time}
                          onChange={(value) =>
                            reminderHelpers.handleChange("time", value)
                          }
                          timeIntervals={15}
                          disabled={!taskReminder.exist}
                        />
                      </div>
                    </div>
                    {taskReminder.reminder.id == 1 &&
                      taskReminder.reminderRecurring.name === "Custom" && (
                        <div className="elements-container">
                          <div className="left-element">
                            <div className="row-container">
                              <h4>Repeat every</h4>
                              <input
                                id="reminderDays"
                                name="reminderDays"
                                value={taskReminder.days}
                                type="number"
                                min={1}
                                required
                                onChange={(e) => {
                                  e.target.value =
                                    e.target.value == 0 ? 1 : e.target.value;
                                  handleChange(e);
                                  reminderHelpers.handleChange(
                                    "days",
                                    e.target.value
                                  );
                                }}
                                isInvalid={errors.reminderDays}
                                onKeyDown={(e) => {
                                  (e.key === "Enter" ||
                                    e.key === "." ||
                                    e.key === "-") &&
                                    e.preventDefault();
                                }}
                                disabled={!taskReminder.exist}
                              />
                              <div className="row-dropdown">
                                <DropdownMain
                                  values={
                                    reminderHelpers.reminderRecurringIntervalTypeValues
                                  }
                                  dropdownButtonText={"-Select-"}
                                  onSelect={(selectedValue) => {
                                    reminderHelpers.handleChange(
                                      "reminderRecurringIntervalType",
                                      selectedValue
                                    );
                                  }}
                                  currentSelected={
                                    taskReminder.reminderRecurringIntervalType
                                  }
                                  disabled={!taskReminder.exist}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {taskReminder.reminder.id == 4 && (
                      <div className="overflowFix">
                        <div className="customReminderContainer">
                          {customReminders.length > 0 ? (
                            <table>
                              <thead>
                                <tr>
                                  <th>REMINDER NAME (optional)</th>
                                  <th>UNIT</th>
                                  <th>PERIOD</th>
                                  <th>DATE</th>
                                  <th>TIME (Local)</th>
                                  <th>TIME (UTC)</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {customReminders.map((cr, idx) => (
                                  <tr className="reminderRow" key={cr.Id}>
                                    <td className="reminderName">
                                      <div className="reminderInputContainer">
                                        <span className="reminderIndex">{idx + 1}</span>
                                        <input
                                          type="text"
                                          value={cr.Name}
                                          onChange={(e) => {
                                            reminderChangeHandler(
                                              "Name",
                                              e.target.value,
                                              idx
                                            );
                                          }}
                                          placeholder="For example, Follow-up #1, Reminder #1, etc."
                                          maxLength={56}
                                          disabled={!taskReminder.exist}
                                        />
                                      </div>
                                      <div className="reminder-name-character-text">
                                        Enter a maximum of 56 characters.
                                      </div>

                                    </td>
                                    <td className="reminderUnits">
                                      <input
                                        value={cr.Unit}
                                        type="number"
                                        defaultValue={2}
                                        min={1}
                                        required
                                        onKeyDown={(e) => {
                                          (e.key === "Enter" ||
                                            e.key === "." ||
                                            e.key === "-") &&
                                            e.preventDefault();
                                        }}
                                        onChange={(e) => {
                                          reminderChangeHandler(
                                            "Unit",
                                            e.target.value,
                                            idx
                                          );
                                        }}
                                        onBlur={(e) => {
                                          if (e.target.value == 0) {
                                            e.target.value = 1;
                                            reminderChangeHandler(
                                              "Unit",
                                              e.target.value,
                                              idx
                                            );
                                          }
                                        }}
                                        disabled={!taskReminder.exist}
                                      />
                                    </td>
                                    <td className="reminderPeriod">
                                      <div className="row-dropdown">
                                        <DropdownMain
                                          values={
                                            customReminderHelpers.reminderRecurringIntervalTypeValues
                                          }
                                          dropdownButtonText={"-Select-"}
                                          onSelect={(selectedValue) => {
                                            reminderChangeHandler(
                                              "Period",
                                              selectedValue.id,
                                              idx
                                            );
                                          }}
                                          currentSelected={{ name: cr.Period }}
                                          disabled={!taskReminder.exist}
                                          additonalClasses={
                                            "overflowSetAbsolute dropdown-custom-reminders"
                                          }
                                          alignRight={true}
                                        />
                                      </div>
                                    </td>
                                    <td className="reminderType">
                                      <div className="reminder-dropdown">
                                        <DropdownMain
                                          values={
                                            reminderHelpers.reminderValues
                                          }
                                          dropdownButtonText={"-Select-"}
                                          onSelect={(selectedValue) => {
                                            reminderChangeHandler(
                                              "ReminderType",
                                              selectedValue.name,
                                              idx
                                            );
                                          }}
                                          currentSelected={{
                                            name: cr.ReminderType,
                                          }}
                                          disabled={!taskReminder.exist}
                                          additonalClasses={
                                            "overflowSetAbsolute"
                                          }
                                          alignRight={true}
                                        />
                                      </div>
                                    </td>
                                    <td className="reminderTime">
                                      <div className="reminder-date-picker">
                                        <FluentTime
                                          value={new Date(cr.ReminderTime)}
                                          onChange={(value) =>
                                            reminderChangeHandler(
                                              "ReminderTime",
                                              value,
                                              idx
                                            )
                                          }
                                          timeIntervals={15}
                                          disabled={!taskReminder.exist}
                                        />
                                      </div>
                                    </td>
                                    <td className="reminderTimeUTC">
                                      <div>
                                        {`${addDateZeroes(new Date(cr.ReminderTime).getUTCHours(), true)}:${addDateZeroes(new Date(cr.ReminderTime).getMinutes(), false)}`}
                                      </div>
                                    </td>
                                    <td className="reminderDelete">
                                      <Button
                                        className="delete-icon btn-icon1 btn btn-primary"
                                        onClick={() => deleteReminder(idx)}
                                        type="button"
                                        disabled={!taskReminder.exist}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div className="emptyCustomReminder">
                              <h3>Custom Task Reminders</h3>
                              <p>
                                To set up Task Reminders with custom delivery
                                schedule, Click the Add New Reminder button
                                below
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {taskReminder.reminder.id != 4 ? (
                      <h4 className="recurrence-details">
                        Reminder will be sent
                        {taskReminder.reminder.id == 0 && " on due date "}
                        {taskReminder.reminder.id == 1 &&
                          (taskReminder.reminderRecurring.name === "Custom"
                            ? ` every ${taskReminder.days
                            } ${taskReminder.reminderRecurringIntervalType.name.toLowerCase()} after start date`
                            : ` ${taskReminder.reminderRecurring.name.toLowerCase()}`)}
                        {(taskReminder.reminder.id == 2 ||
                          taskReminder.reminder.id == 3) &&
                          ` ${taskReminder.days
                          } days ${taskReminder.reminder.name.toLowerCase()} `}
                        {" at " + getTimeFromTimeStamp(taskReminder.time)}
                      </h4>
                    ) : (
                      <div className="d-flex justify-content-between">
                        <div>
                          {customReminders.length != 0 && (
                            <h4 className="recurrence-details">
                              {customReminders.length == 1
                                ? " 1 Task Reminder has been set"
                                : customReminders?.length +
                                " Task Reminders have been set"}
                            </h4>
                          )}
                        </div>
                        <button
                          className="newReminder btn"
                          onClick={addReminder}
                        >
                          <span className="add-reminder-btn-text">
                            Add New Reminder
                          </span>
                          <div className="add-field-icon" />
                        </button>
                      </div>
                    )}
                  </>
                </div>
              </Form.Row>

              <div className="clearfix" />
              {!promiseInProgress && (
                <div className="admin-dynamic-fields-panel-wrapper">
                  {!showModal && (
                    <AdminDynamicFieldsTemplate
                      dynamicFields={dynamicFields}
                      setDynamicFields={setDynamicFields}
                      objectTypes={objectTypes}
                      checked={checked}
                    />
                  )}
                  {showModal && (
                    <TaskTypesCreationModal
                      show={showModal}
                      editMode={editMode}
                      hideModal={() => setShowModal(false)}
                    />
                  )}
                </div>
              )}
              <div className="float-right mt-5 pb-5">
                <Button
                  className="btn-wide btn-outlined"
                  type="button"
                  disabled={promiseInProgress}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  className="btn-wide"
                  type="button"
                  disabled={promiseInProgress || disableSubmit || (enableCustomizedWorkflow && taskType.WorkflowId == NIL_UUID)}
                  onClick={submitForm}
                >
                  {editMode ? "Save" : "Create"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {showCancelModal && (
        <CancelModal
          show={showCancelModal}
          onHide={() => setShowCancelModal(false)}
          redirectURL={"/admin?tab=task-types"}
        />
      )}
    </div>
  );
};

export default AdminDynamicFieldsPage;
